import React from 'react';
import FittedImage from 'react-fitted-img';
import './SubsidiarySite.css';
import Button from '../Button/Button';
import { ComponentTheme } from '../../definitions/components';
import { truncate } from '../../services/utils';

export enum SubsidiarySiteAlignment {
  LEFT = 'content-left',
  RIGHT = 'content-right'
}

export interface ISubsidiarySiteProps extends React.HTMLProps<HTMLDivElement> {
  name: string;
  image: string;
  link: string;
  info: string;
  alignment?: SubsidiarySiteAlignment;
  theme?: ComponentTheme;
  btnTheme?: ComponentTheme;
  bgImage?: string;
}

const SubsidiarySite = (props: ISubsidiarySiteProps) => {
  const {
    name,
    info,
    alignment = SubsidiarySiteAlignment.RIGHT,
    image,
    link,
    theme = ComponentTheme.LIGHT,
    btnTheme = ComponentTheme.DARK_TRANSPARENT,
    children,
    bgImage
  } = props;

  return (
    <div
      className={`subsidiary-site ${theme} ${alignment}`}
      style={bgImage ? { backgroundImage: `url('${bgImage}')` } : undefined}>

      <div className="container">
        <div className="row middle-xs">
          <div className="image-content col-xs-12 col-sm-6">
            <FittedImage
              src={image}
              alt={name}
              fit='contain'
              decoding="async"
              srcSet={`${image} 240w`}
              sizes="
                (min-width: 320px) 340px,
                (min-width: 768px) 320px,
                (min-width: 1024px) 460px,
                (min-width: 1200px) 570px
              "
            />
          </div>

          <div className="content col-xs-12 col-sm-6">
            <p className="name">
              {name}
            </p>
            <div className="info-container">
              <p className="info">
                {truncate(info, 230)}
              </p>
              {children}
            </div>
            <Button link={link} theme={btnTheme} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubsidiarySite;



// WEBPACK FOOTER //
// ./src/components/SubsidiarySite/index.tsx